import PropTypes from "prop-types";
import React, { Component } from "react";
import CONSTANTS from '../../constants/index'
import "./gp-web-payment.css";
import _ from 'lodash'

export default class GPWebPayment extends Component {
  constructor(props) {
    super(props);
    
    const {firstName, lastName, email, access_token} = props.auth.authData ? props.auth.authData : {};

    this.state = {
      firstName: firstName,
      lastName: lastName,
      email: email,
      password: '',
      confirmPassword: '',
      paymentEnabled: false,
      hostedFieldsInstance: null,
      errorFields: {
        generic: props.genericError ? props.genericError : undefined
      },
      isLoggedIn: access_token !== undefined,
      termsAccepted: false
    }

  }

  componentDidUpdate(prevProps, prevState) {
    const self = this;

    if (this.props.genericError && (this.props.genericError !== this.state.errorFields.generic)) {
      this.setState({
        ...this.state,
        errorFields: {
          ...this.state.errorFields,
          generic: this.props.genericError
        },
        paymentEnabled: true
      })
    }

    if (this.props.paymentGateway.braintreeHostedFields && !prevProps.paymentGateway.braintreeHostedFields) {
      this.props.paymentGateway.braintreeHostedFields.on('validityChange', (evt) => {
        const {emittedBy, fields} = evt;
        
        const hasError = !fields[emittedBy].isValid;
        if (hasError) {
          fields[emittedBy].container.classList.add('error-input');
        } else {
          fields[emittedBy].container.classList.remove('error-input');
        }

        self.setState({
          ...self.state,
          errorFields: {
            ...self.state.errorFields,
            [emittedBy]: !hasError ? '' : self.props.t(`BRAINTREE_${emittedBy}_ERROR`)
          }
        })
      })

      self.setState({
        ...self.state,
        hostedFieldsInstance: this.props.paymentGateway.braintreeHostedFields,
        paymentEnabled: true
      });
    }

    if (this.props.registration && (this.props.registration !== prevProps.registration)) {
      this.setState({
        ...this.state,
        errorFields: {
          ...this.state.errorFields,
          generic: this.props.registration.error ? this.props.registration.error : this.state.errorFields.generic
        },
        paymentEnabled: this.props.registration.error ? true : false
      })
    }

    if (this.props.session && (this.props.session !== prevProps.session)) {
      this.setState({
        ...this.state,
        errorFields: {
          ...this.state.errorFields,
          generic: this.props.session.error ? this.props.session.error : undefined
        }
      })
    }

    if (this.props.paymentGateway.adFreePayment && prevProps.paymentGateway && (this.props.paymentGateway.adFreePayment !== prevProps.paymentGateway.adFreePayment)) {
      const {error, errorMessage} = this.props.paymentGateway.adFreePayment;
      if (error) {
        this.setState({
          ...this.state,
          errorFields: {
            ...this.state.errorFields,
            generic: errorMessage
          }
        })
      }
    }
  }

  validateForm = () => {
    const fieldsWithErrors = [];
    fieldsWithErrors.push(...['email', 'firstName', 'lastName', 'termsAccepted'].filter(field => !this.state[field]));

    if(!this.state.isLoggedIn) {
      fieldsWithErrors.push(...['password', 'confirmPassword'].filter(field => !this.state[field]));
    }

    if (this.state.hostedFieldsInstance) {
      const {fields} = this.state.hostedFieldsInstance.getState();
      // reset errors on fields
      Object.keys(fields).forEach(field => fields[field].container.classList.remove('error-input'));

      const paymentFormFieldsWithErrors = Object.entries(fields).filter(([field, data]) => data.isValid === false).map(([field, value]) => field);
      paymentFormFieldsWithErrors.forEach(field => fields[field].container.classList.add('error-input'));

      fieldsWithErrors.push(...paymentFormFieldsWithErrors);
    }

    if (fieldsWithErrors.length) {
      const errorFields = {};
      fieldsWithErrors.forEach(field => errorFields[field] = ' ');
      this.setState({
        ...this.state,
        errorFields
      })

      return true;
    } else {
      this.setState({
        ...this.state,
        errorFields: {}
      })

      return false;
    }
  }

  formSubmission = (e) => {
    e.preventDefault();

    try {
      const self = this;

      const hasErrors = this.validateForm();
      
      if (!hasErrors) {
        this.setState({
          ...this.state,
          paymentEnabled: false
        })

        this.state.hostedFieldsInstance.tokenize()
          .then(function(payload) {
            const {nonce, details} = payload;
            const {email, firstName, lastName, password} = self.state;

            const { paymentHandler } = self.props;

            paymentHandler({
              email,
              firstName,
              lastName,
              password,
              threedsecure: {
                nonce,
                details,
                amount: self.props.basket.totalPrice
              }
            })
            
          })
          .catch(function(e) {
            console.log(e);

            self.setState({
              ...self.state,
              errorFields: {
                ...self.state.errorFields,
                generic: self.props.t('GENERIC_ERROR')
              },
              paymentEnabled: true
            })
          });
      }
      
    } catch (e) {
      console.log(e);
    }
  };

  userFirstNameHandler = (e) => {
    this.setState({
      ...this.state,
      firstName: e.target.value,
      errorFields: {
        ...this.state.errorFields,
        firstName: !e.target.value ? this.props.t('FIRST_NAME_ERROR') : ''
      }
    });

  };

  userLastNameHandler = (e) => {
    this.setState({
      ...this.state,
      lastName: e.target.value,
      errorFields: {
        ...this.state.errorFields,
        lastName: !e.target.value ? this.props.t('LAST_NAME_ERROR') : ''
      }
    });

  };

  userPasswordHandler = (e) => {
    const password = e.target.value;
    this.setState({
      ...this.state,
      password: e.target.value,
      errorFields: {
        ...this.state.errorFields,
        password: (password.length < CONSTANTS.AUTH_MIN_PASSWORD_LENGTH) || (password.length > CONSTANTS.AUTH_MAX_PASSWORD_LENGTH) ? this.props.t('ERROR_PASSWORD_LENGTH') : '',
        confirmPassword: (e.target.value !== this.state.confirmPassword) ? this.props.t('ACCOUNT_PASSWORDS_VALIDATION') : ''
      }
    });

  }

  userConfirmPasswordHandler = (e) => {
    const confirmPassword = e.target.value;
    this.setState({
      ...this.state,
      confirmPassword: e.target.value,
      errorFields: {
        ...this.state.errorFields,
        confirmPassword: (confirmPassword.length < CONSTANTS.AUTH_MIN_PASSWORD_LENGTH) || (confirmPassword.length > CONSTANTS.AUTH_MAX_PASSWORD_LENGTH) ? this.props.t('ERROR_PASSWORD_LENGTH') : (confirmPassword !== this.state.password) ? this.props.t('ACCOUNT_PASSWORDS_VALIDATION') : ''
      }
    });

  }

  emailHandler = (e) => {
    this.setState({
      ...this.state,
      email: e.target.value,
      errorFields: {
        ...this.state.errorFields,
        email: !e.target.value ? this.props.t('EMAIL_ERROR') : ''
      }
    });
  };

  termsHandler = (e) => {
    this.setState({
      ...this.state,
      termsAccepted: e.target.checked,
      errorFields: {
        ...this.state.errorFields,
        termsAccepted: !e.target.checked ? this.props.t('TERM_OF_USE_ERROR') : ''
      }
    });
  };

  generateLinkMarkup = (url, text) => {
    let markup = ''

    if (url && text) {
      markup = `<a class="terms_link" href="${url}" target="_blank">${text}</a>`
    } else if (!url && text) {
      markup = text
    }

    return markup
  }

  generateSiteLocaleLink = (pageData, locale, key) => {
    const localeFormatted = locale.replace('-', '_')

    if (pageData && pageData.locales && pageData.locales[localeFormatted]) {
      if (pageData.locales[localeFormatted][key]) {
        return pageData.locales[localeFormatted][key]
      }
    } else if (pageData[key]) {
      return pageData[key]
    }

    return false
  }

  render() {
    const { t, paymentGateway, basket: {currencySymbol, totalPrice} } = this.props;
    const {firstName, lastName, email, password, confirmPassword, termsAccepted} = this.state;
    
    const termsLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'terms_and_conditions'),
      t('GP_TERMS_AND_CONDITIONS'),
    )
    const privacyLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'privacy_policy'),
      t('GP_PRIVACY_POLICY'),
    )
    const adFreeTermsLink = this.generateLinkMarkup(
      this.generateSiteLocaleLink(CONSTANTS.PAGES, CONSTANTS.LOCALE, 'ad_free_terms_and_conditions'),
      t('GP_AD_FREE_TERMS_AND_CONDITIONS'),
    )

    const termsCopy = t('GP_ORDER_TERMS', {terms_and_conditions: termsLink, privacy_policy: privacyLink, ad_free_terms_and_conditions: adFreeTermsLink})

    /* eslint-disable */
    return (
      <div className="payment">
        <div className="payment__content">
          <form onSubmit={this.formSubmission}>

            <div className="payment__table">
              {
                this.state.isLoggedIn && 
                <div className="details__field">
                  <div className="details__header">
                    <p className="payment__title details__title">1.&nbsp;{t('GP_YOUR_DETAILS')}</p>
                  </div>
                  <p className="details__name">{t("FIRST_NAME")}: {`${firstName}`}</p>
                  <p className="details__name">{t("LAST_NAME")}: {`${lastName}`}</p>
                  <p className="details__email">{t('EMAIL')}: {email}</p>
                  <input
                    id="txt-email"
                    type="hidden"
                    value={email}
                  />
                  <input
                    id="txt-first-name"
                    type="hidden"
                    value={firstName}
                  />
                  <input
                    id="txt-last-name"
                    type="hidden"
                    value={lastName}
                  />
                </div>
              }
              {
                !this.state.isLoggedIn &&
                <div>
                  <p className="payment__title">1.&nbsp;{t('GP_YOUR_DETAILS')}</p>
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-email">{t("EMAIL")}</label>
                    <input
                      id="txt-email"
                      className={`payment__input ${this.state.errorFields['email'] && 'error-input'}`}
                      type="email"
                      value={email}
                      onChange={this.emailHandler}
                    />
                    { this.state.errorFields['email'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['email']}</span>
                    }
                  </div>
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-first-name">{t("FIRST_NAME")}</label>
                    <input
                      id="txt-first-name"
                      className={`payment__input ${this.state.errorFields['firstName'] && 'error-input'}`}
                      type="text"
                      value={firstName}
                      onChange={this.userFirstNameHandler}
                    />
                    { this.state.errorFields['firstName'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['firstName']}</span>
                    }
                  </div>
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-last-name">{t("LAST_NAME")}</label>
                    <input
                      id="txt-last-name"
                      className={`payment__input ${this.state.errorFields['lastName'] && 'error-input'}`}
                      type="text"
                      value={lastName}
                      onChange={this.userLastNameHandler}
                    />
                    { this.state.errorFields['lastName'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['lastName']}</span>
                    }
                  </div>
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-password">{t("PASSWORD")}</label>
                    <input
                      id="txt-password"
                      className={`payment__input ${this.state.errorFields['password'] && 'error-input'}`}
                      type="password"
                      value={password}
                      onChange={this.userPasswordHandler}
                    />
                    { this.state.errorFields['password'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['password']}</span>
                    }
                  </div>

                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-confirm-password">{t("CONFIRM_PASSWORD")}</label>
                    <input
                      id="txt-confirm-password"
                      className={`payment__input ${this.state.errorFields['confirmPassword'] && 'error-input'}`}
                      type="password"
                      value={confirmPassword}
                      onChange={this.userConfirmPasswordHandler}
                    />
                    { this.state.errorFields['confirmPassword'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['confirmPassword']}</span>
                    }
                  </div>
                </div>
              }
            </div>
            <div>
              <div className="payment__table">
                <p className="payment__title">2.&nbsp;{t('GP_PAYMENT_METHOD')}</p>
                <div className="payment__field">
                  <label className="payment__label" htmlFor="txt-name-on-card">{t("GP_NAME_CARD")}</label>
                  <div
                    id="txt-name-on-card"
                    className="payment__input"/>
                  { this.state.errorFields['cardholderName'] &&
                    <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['cardholderName']}</span>
                  }
                </div>
                <div className="payment__field">
                  <label className="payment__label" htmlFor="txt-card-number">{t("GP_CARD_NUMBER")}</label>
                  <div id="txt-card-number" className="payment__input"/>
                  { this.state.errorFields['number'] &&
                    <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['number']}</span>
                  }
                </div>

                <div className="payment__row">
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-expiry-date">{t("GP_EXPIRY_DATE")}</label>
                    <div
                      id="txt-expiry-date"
                      className="payment__input"/>
                    { this.state.errorFields['expirationDate'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['expirationDate']}</span>
                    }
                  </div>
                  <div className="payment__field">
                    <label className="payment__label" htmlFor="txt-cvv">{t("GP_CVV")}</label>
                    <div
                      id="txt-cvv"
                      className="payment__input"/>
                    { this.state.errorFields['cvv'] &&
                      <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['cvv']}</span>
                    }
                  </div>
                </div>

                <div className="payment__field">
                  <label className="payment__label" htmlFor="txt-post-code">{t("GP_POST_CODE")}</label>
                  <div
                    id="txt-post-code"
                    className="payment__input"/>
                  { this.state.errorFields['postalCode'] &&
                    <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['postalCode']}</span>
                  }
                </div>

                { this.state.errorFields['generic'] &&
                  <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['generic']}</span>
                }

              </div>

              <div className="payment__terms">
                <label htmlFor="terms">
                  <input
                    type="checkbox"
                    id="terms"
                    className="check"
                    checked={termsAccepted}
                    onChange={this.termsHandler}
                  />
                  <span className={`terms-consent ${this.state.errorFields['termsAccepted'] ? 'xs-text-red' : ''}`} dangerouslySetInnerHTML={{__html: termsCopy}} />
                  { this.state.errorFields['termsAccepted'] &&
                    <span className="xs-block xs-text-red xs-mt1 xs-mb2">{this.state.errorFields['termsAccepted']}</span>
                  }
                </label>
              </div>
              <div className="payment__terms">
                <span className="terms-consent" dangerouslySetInnerHTML={{__html: t("GP_ORDER_DISCLAIMER")}}/>
              </div>

              <button className={`button-primary xs-border-none xs-pt1 xs-text-white xs-col-12 xs-text-7 ${this.state.paymentEnabled ? '' : 'disabled'}`} type="submit">{t('GP_PAY_VALUE', {value: `${currencySymbol}${totalPrice}`})}</button>

            </div>

          </form>
        </div>
      </div>
    );
    /* eslint-enable */
  }
}

GPWebPayment.propTypes = {
  t: PropTypes.func.isRequired,
};

GPWebPayment.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/gp-web-payment/gp-web-payment.js